import styled from "styled-components";

export const HomeStyled = styled.div`
  .home-content-container {
    display: flex;
    gap: 150px;
    margin-top: 20px;
  }

  .View-offer-button {
    position: absolute;
    z-index: 9999;
    bottom: 90px;
    height: 40px !important;
    width: 164px;
    left: 54px;
    border-radius: 20px;
    cursor: pointer;
  }

  .slick-arrow {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #fff;
    color: #fff;
    font-size: 0px;
    content: "" !important;
    z-index: 9;
    box-shadow: 0px 0px 36px 0px rgba(0, 0, 0, 0.13);
    margin-top: -30px;
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
  .slick-arrow::before {
    margin-bottom: 5px;
  }
  .ant-carousel .slick-prev::before {
    content: "<" !important;
    color: #000 !important;
    font-size: 25px;
    margin-bottom: 5px;
  }
  .ant-carousel .slick-next::before {
    content: ">" !important;
    color: #000 !important;
    font-size: 25px;
    margin-bottom: 5px;
  }
  .ant-carousel .slick-arrow:hover {
    background: #fff !important;
    color: #fff !important;
  }
  .top_brands_styled {
    position: relative;
    background: var(--www-farfetch-com-mine-shaft-4, rgba(34, 34, 34, 0.04));
    padding-top: 5px;
  }

  .ofefr_sm_banner {
    padding: 30px;
  }
  .slick-dots {
    bottom: 20px !important;
  }
  .ant-carousel .slick-dots li {
    width: 12px !important;
    height: 12px !important;
    border: 1px solid #ffff;
    border-radius: 50%;
  }
  .ant-carousel .slick-dots li.slick-active button {
    background: transparent !important;
    opacity: 1;
  }
  .ant-carousel .slick-dots li.slick-active {
    background: orange !important;
  }
  .ant-carousel .slick-dots li button:hover {
    background: transparent !important;
  }
  .banner_img_carsousel .slick-slide {
    aspect-ratio: 100 / 36;
    div:first-child {
      height: 100%;
    }
  }

  .carouse_image_wrapper {
    position: relative;
    display: flex !important;
    .text-div {
      padding: 80px 75px;
      width: 50%;
      .merchant-logo {
        width: 100px;
        height: 100px;
        object-fit: contain;
      }
      h3 {
        font-family: Inter;
        font-weight: 700;
        font-style: Bold;
        font-size: 40px;
        line-height: 50px;
        letter-spacing: 0%;
        color: #fff;
      }
      p {
        font-family: Inter;
        font-weight: 500;
        font-style: Medium;
        font-size: 18px;
        line-height: 28px;
        letter-spacing: 0%;
        color: #fff;
      }
      button {
        width: 156px;
        height: 40px;
        border-radius: 34px;
        font-family: Inter;
        font-weight: 600;
        font-style: Semi Bold;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: 0.2%;
        text-transform: uppercase;
        background: #000000;
        color: #fff;
        border: none;
        cursor: pointer;
      }
    }
    .image-div {
      width: 50%;
      background: #000;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .carousel-arrow {
    position: absolute;
    top: 45%;
    border: none !important;
    cursor: pointer;
    z-index: 10;
    width: 40px;
    height: 40px;
    background: #ffffff;
    border-radius: 50%;
  }
  .carousel-arrow img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .left-arrow {
    left: 10px;
  }

  .right-arrow {
    right: 10px;
    rotate: 180deg;
  }

  .home-container {
    padding-left: 30px;
    padding-right: 30px;
  }
  .instruction-text h3 {
    font-family: Inter;
    font-size: 28px;
    font-weight: 700;
    line-height: 26px;
    color: #ffffff;
  }

  .instruction-text p {
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 23px;
    color: #ffffff;
  }
  .ant-carousel .slick-dots li button {
    background: transparent !important;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  .instruction-section .arrow-icon-section img {
    width: 64px;
    height: 64px;
  }

  .home-container {
    padding-left: 30px;
    padding-right: 30px;
  }
  .instruction-text h3 {
    font-family: Inter;
    font-size: 28px;
    font-weight: 700;
    line-height: 26px;
    color: #ffffff;
  }

  .instruction-text p {
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 23px;
    color: #ffffff;
  }
  .ant-carousel .slick-dots li button {
    background: transparent !important;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  .instruction-section .arrow-icon-section img {
    width: 64px;
    height: 64px;
  }

  // Mobile Responsiveness

  @media screen and (max-width: 767px) {
    .instruction-section .instruction-text h3 {
      font-size: 16px;
    }
    .instruction-section .instruction-text p {
      font-size: 14px;
    }
    .instruction-section .arrow-icon-section img {
      width: 40px;
      height: 40px;
    }
    .home-container {
      padding-left: 16px;
      padding-right: 16px;
    }
    .carousel-arrow {
      width: 25px;
      height: 25px;
    }

    .banner_img_carsousel .slick-slide {
      aspect-ratio: 1 / 1;
      div:first-child {
        height: 100%;
      }
    }

    .carouse_image_wrapper {
      position: relative;
      display: flex !important;
      flex-direction: column;
      height: 100%;
      .text-div {
        padding: 10px 10px;
        width: 100%;
        height: 50%;
        .merchant-logo {
          width: 30px;
          height: 30px;
          object-fit: contain;
          margin-bottom: 10px;
        }
        h3 {
          font-size: 13px;
          line-height: 14px;
          letter-spacing: 0%;
          color: #fff;
        }
        p {
          font-size: 12px;
          line-height: 12px;
          letter-spacing: 0%;
          color: #fff;
          margin-bottom: 10px;
        }
        button {
          width: 90px;
          height: 30px;
          font-size: 10px;
          border: none;
          cursor: pointer;
          line-height: 10px;
        }
      }
      .image-div {
        width: 100%;
        height: 50%;
        background: #000;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
`;
